import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { connect } from "react-redux"

import Layout from "../components/layout"
import Filters from "../components/filters"
import SEO from "../components/seo"
import TutoCard from "../components/tutoCard"
import "../components/tutoCard.css"
import loFilter from "lodash/filter"
import loUnion from "lodash/union"
import loSlice from "lodash/slice"
import _isEmpty from "lodash/isEmpty"
// import he from "he"

import { setTutos, setFiltered, setCurrentQuery, setReset } from "../state/app"

const TutosVideos = ({ tutos, filtered, currentQuery, reset, dispatch }) => {
  const data = useStaticQuery(graphql`
    query {
      allWordpressWpTablature(
        filter: { meta: { tablature_lienTutoYoutube: { ne: "" } } }
      ) {
        edges {
          node {
            wordpress_id
            title
            artist
            difficulty
            style
            slug
            meta {
              tablature_lienTutoYoutube
            }
          }
        }
      }
      allWordpressWpArtiste {
        edges {
          node {
            name
            wordpress_id
          }
        }
      }
      allWordpressWpDifficulte(sort: { fields: wordpress_id, order: ASC }) {
        edges {
          node {
            name
            wordpress_id
          }
        }
      }
      allWordpressWpStyle {
        edges {
          node {
            name
            wordpress_id
          }
        }
      }
    }
  `)

  const [difficulty, setDifficulty] = useState("")
  const [style, setStyle] = useState("")
  //Need that to do the pagination
  const [finalTutos, setFinalTutos] = useState([])
  //FilteredResults
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [filters, setFilters] = useState({ firstRender: true })
  const perPage = 36

  //test use effect with reset
  useEffect(() => {
    // console.log(`Reset called`, reset);
    if (reset) {
      setFilters({})
      setDifficulty("")
      setStyle("")
      applyFilters(true)
      dispatch(setReset(false))
    }
  }, [reset])

  useEffect(() => {
    dispatch(setCurrentQuery(""))

    const tutos = data.allWordpressWpTablature.edges

    const totalPages = Math.ceil(tutos.length / perPage)
    setTotalPages(totalPages)

    dispatch(setTutos(tutos))
    const final = loSlice(tutos, (page - 1) * perPage, perPage * page)
    setFinalTutos(final)
    setFilters({ firstRender: false })
  }, [])

  useEffect(() => {
    if (currentQuery !== "") {
      setDifficulty("")
      setStyle("")
      delete filters.difficulty
      delete filters.style
      setFilters(old => {
        return {
          ...old,
          query: currentQuery,
        }
      })
      // search()
    }
  }, [currentQuery])

  useEffect(() => {
    if (!filters.firstRender) {
      applyFilters()
    }
  }, [filters])

  const applyFilters = (reset = false) => {
    let results = []

    if (reset) {
      results = tutos
    } else {
      if (filters["query"] && filters["query"] !== "") {
        const pattern = new RegExp(filters["query"], "gi")
        const titleResults = loFilter(tutos, item => {
          return item.node.title.replace(/&rsquo;/g, "'").match(pattern)
        })

        const artistResults = loFilter(tutos, item => {
          return item.node.artist.replace(/&rsquo;/g, "'").match(pattern)
        })

        results = loUnion(titleResults, artistResults)
      }

      if (filters["style"] && filters["difficulty"]) {
        results = loFilter(
          filters["query"] && filters["query"] !== "" ? results : tutos,
          el => {
            return (
              el.node.style === filters["style"] &&
              el.node.difficulty === filters["difficulty"]
            )
          }
        )
      } else if (filters["style"] && !filters["difficulty"]) {
        results = loFilter(
          filters["query"] && filters["query"] !== "" ? results : tutos,
          el => el.node.style === filters["style"]
        )
      } else if (filters["difficulty"] && !filters["style"]) {
        const arrayToUse =
          filters["query"] && filters["query"] !== "" ? results : tutos
        results = loFilter(
          arrayToUse,
          el => el.node.difficulty === filters["difficulty"]
        )
      } else {
        if (!filters["query"]) {
          console.log(`tutos`, tutos)
          results = tutos
        }
      }
    }

    const currentPage = 1
    const final = loSlice(
      results,
      (currentPage - 1) * perPage,
      perPage * currentPage
    )
    const totalPages = Math.ceil(results.length / perPage)
    setTotalPages(totalPages)
    setPage(1)

    //Keep the results from filters to access them in loadMore for pagination
    dispatch(setFiltered(results))

    setFinalTutos(final)

    window.scrollTo(0, 0)
  }

  const difficultyFilter = e => {
    const diff = e.target.value
    if (diff === "") {
      delete filters.difficulty
      setFilters(old => {
        return { ...old }
      })
    } else {
      setFilters(old => {
        return { ...old, difficulty: diff }
      })
    }
    setDifficulty(diff)
  }

  const styleFilter = e => {
    const style = e.target.value
    if (style === "") {
      delete filters.style
      setFilters(old => {
        return { ...old }
      })
    } else {
      setFilters(old => {
        return { ...old, style }
      })
    }
    setStyle(style)
  }

  const loadMore = () => {
    const currentPage = page + 1
    //Not working apparently. Use currentPage instead
    setPage(currentPage)

    if (currentPage <= totalPages) {
      let final = []
      if (!_isEmpty(filters)) {
        final = loSlice(
          filtered,
          (currentPage - 1) * perPage,
          perPage * currentPage
        )
      } else {
        final = loSlice(
          tutos,
          (currentPage - 1) * perPage,
          perPage * currentPage
        )
      }
      setFinalTutos(loUnion(finalTutos, final))
    }
  }

  const resetFilters = () => {
    dispatch(setReset(true))
    dispatch(setCurrentQuery(""))
  }

  return (
    <Layout>
      <SEO title="Tutos & Tablatures" />

      <div className="container-lg">
        <div className="row">
          {/* Filters on large screen */}
          <div className="d-none d-lg-block col-lg-3 left-col">
            <h2 className="h4">Filtres</h2>
            <hr />
            {/* Difficulty */}
            <div className="form-group">
              <select
                className="form-control"
                value={difficulty}
                onChange={difficultyFilter}
                aria-label="Sélectionner une Difficulté"
              >
                <option value="">Choisir une difficulté</option>
                {data.allWordpressWpDifficulte.edges.map(({ node }) => {
                  return (
                    <option
                      value={node.name}
                      key={node.wordpress_id}
                      dangerouslySetInnerHTML={{ __html: node.name }}
                    ></option>
                  )
                })}
              </select>
            </div>

            {/* Style */}
            <div className="form-group">
              <select
                className="form-control"
                value={style}
                onChange={styleFilter}
                aria-label="Sélectionner un style"
                tabIndex={0}
              >
                <option value="">Choisir un style</option>
                {data.allWordpressWpStyle.edges.map(({ node }) => {
                  return (
                    <option
                      value={node.name}
                      key={node.wordpress_id}
                      dangerouslySetInnerHTML={{ __html: node.name }}
                    ></option>
                  )
                })}
              </select>
            </div>

            {/* Bouton reset */}
            <div className="form-group">
              <button
                className="btn btn-danger"
                onClick={resetFilters}
                tabIndex={0}
              >
                Reset
              </button>
            </div>
          </div>
          <div className="col-md-12 col-lg-9 right-col">
            {finalTutos.length === 0 && filters.firstRender === false && (
              <div className="text-center" style={{ minHeight: "60vh" }}>
                Aucun tuto trouvé. Essayez d'enlever certains filtres...
              </div>
            )}

            {finalTutos.length > 0 && (
              <div className="row tutos-container">
                {finalTutos.map(({ node }) => {
                  return <TutoCard key={node.wordpress_id} tuto={node} />
                })}
              </div>
            )}
            {page < totalPages && (
              <div className="row justify-content-center">
                <button className="btn btn-dark" onClick={loadMore}>
                  Voir plus
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Filters */}
        <Filters
          difficulties={data.allWordpressWpDifficulte.edges}
          styles={data.allWordpressWpStyle.edges}
          difficulty={difficulty}
          style={style}
          difficultyFilter={difficultyFilter}
          styleFilter={styleFilter}
        />
      </div>
    </Layout>
  )
}

export default connect(
  state => ({
    tutos: state.app.tutos,
    filtered: state.app.filtered,
    currentQuery: state.app.currentQuery,
    reset: state.app.reset,
  }),
  null
)(TutosVideos)
